import parse from 'html-react-parser'
import { createClient } from 'graphqurl'
import { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import Link from 'next/link'

import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'

import styles from '../../styles/JobPoster.module.scss'

const ViewedPosters = ({
	showViewedPosters, setShowViewedPosters,
	viewedPosters, setViewedPosters // Remove
}) => {
	const [states, setStates] = useState({
		isFetching: false, // Disable Button
		renderQRCode: false
	})
	const [UUID, setUUID] = useState('')

	const insertSavedJobPosters = () => {
		setStates({ ...states, isFetching: true })
		setUUID('')
		const client = createClient({
			endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string
		})

		if (viewedPosters.length > 0) {
			client.query({
				query: `
				mutation {
					insert_JobPoster_SaveJobs_one(object: {
						kioskSource: null
						language: "EN"
						JobPoster_SaveJobs_Jobs: {
							data: [${viewedPosters.map(poster => {
		return `{jobId: ${poster.id}}`
	})}
						]}
					}) {
						uuid
					}
				}
				`
			})
				.then(res => {
					const { data: { insert_JobPoster_SaveJobs_one: { uuid } }} = res
					
					setUUID(uuid)
					setStates({ isFetching: false, renderQRCode: true })
				})
				.catch(err => {
					console.error(err)
					setUUID('')
					setStates({ isFetching: false, renderQRCode: false })
				})
		}
	}
	return (
		<Modal
			show={showViewedPosters}
			onHide={() => {
				setShowViewedPosters(false)
				if (states.renderQRCode) setStates({ ...states, renderQRCode: false})
			}}
			size='lg'
		>
			<Modal.Header closeButton>
				<Modal.Title>
					<span className='fw-bolder'>My Job Basket</span> (Jobs that you have viewed)
					<br />
					<span className='fs-5'>You can share these jobs with your friends</span>
				</Modal.Title>
			</Modal.Header>

			{!states.renderQRCode ? (
				<Modal.Body>
					<Row data-masonry='{"percentPostion": true}'>
						{viewedPosters.map((poster, index) => {
							if (poster.imageUrl !== null || poster.description !== null || poster.imageUrlChinese !== null || poster.descriptionChinese !== null) {
								const { id, imageUrl, description, imageUrlChinese, descriptionChinese, Company } = poster
								return (
									<Col
										lg='6' md='12' xs='12'
										key={index}
										className='mb-4'
									>
										<Card
											className={styles.card}
										>
											<Card.Body>
												<div className='d-flex justify-content-between align-items-center p-3'>
													<p
														className={styles.paragraph}
													>{Company.name}</p>
													{Company.avatar !== null && <Image width={35} height={35} src={Company.avatar} alt='' className={styles.coImage} />}
												</div>

												{(imageUrl !== null || imageUrlChinese !== null) ? (
													<Image
														src={imageUrl !== null ? imageUrl : imageUrlChinese}
														alt='Job Poster'
														className='w-100'
													/>
												) : (
													<div className={styles.htmlContainer}>
														{parse(description !== null ? description: descriptionChinese)}
													</div>
												)}
												<div className='p-3'>
													<Button
														className='text-white fw-bolder'
														style={{ borderRadius: '10px', width: '100%' }}
														// Remove from Basket
														onClick={() => {
															const filtered = viewedPosters.filter(poster => poster.id !== id)
															setViewedPosters(filtered)
															window.localStorage.setItem('viewed-posters', JSON.stringify(filtered))
														}}
													>Remove</Button>
												</div>
											</Card.Body>
										</Card>
									</Col>
								)
							}
						})}
					</Row>

					<Modal.Footer>
						<Button
							className='text-white fw-bolder'
							style={{ borderRadius: '10px', width: '100%' }}
							onClick={() => {
								insertSavedJobPosters()
							}}
							disabled={states.isFetching || viewedPosters.length === 0}
						>
						Share my Job Basket
						</Button>
					</Modal.Footer>
				</Modal.Body>
			) : (
				<Modal.Body className='text-center'>
					{UUID !== '' && (
						<>
							<div className='my-4'>
								<QRCodeSVG value={`${process.env.NEXT_PUBLIC_DOMAIN}/job-basket/saved/${UUID}`} />
							</div>
							<Link href={`/job-basket/saved/${UUID}`}>
								<a target='_blank' className='text-decoration-underline'>
									{`${process.env.NEXT_PUBLIC_DOMAIN}/job-basket/saved/${UUID}`}
								</a>
							</Link>
							<p className='fs-6'>
								Save the link/Take a screenshot before closing this window
								<br />
								You&apos;ll only see it once
							</p>

						</>
					)}

					<Modal.Footer>
						<Button
							className='text-white fw-bolder'
							style={{ borderRadius: '10px', width: '100%' }}
							onClick={() => {
								setShowViewedPosters(false)
								setStates({ ...states, renderQRCode: false })
							}}
							// disabled={states.isFetching || viewedPosters.length === 0}
						>
						Done
						</Button>
					</Modal.Footer>
				</Modal.Body>
			)}
		</Modal>
	)
}

export default ViewedPosters
